<div class="container auth-container">
  <div class="auth-card">
    <h2 class="auth-title">Daxil ol</h2>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="auth-form">
      <div class="form-group">
        <label for="phoneNumber">Telefon nömrəsi</label>
        <input
          type="text"
          id="phoneNumber"
          formControlName="phoneNumber"
          placeholder="+994 (0XX) XXX-XX-XX"
          (input)="onPhoneInput($event)"
          [class.invalid]="loginForm.get('phoneNumber')?.invalid && loginForm.get('phoneNumber')?.touched"
        >
        <div class="error-message" *ngIf="loginForm.get('phoneNumber')?.invalid && loginForm.get('phoneNumber')?.touched">
          <span *ngIf="loginForm.get('phoneNumber')?.errors?.['required']">Telefon nömrəsi daxil edilməlidir.</span>
          <span *ngIf="loginForm.get('phoneNumber')?.errors?.['pattern']">Düzgün operator daxil etməmisiniz.</span>
        </div>
      </div>

      <div class="form-group">
        <label for="password">Şifrə</label>
        <div class="password-wrapper">
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            formControlName="password"
            placeholder="Şifrənizi daxil edin"
            [class.invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
          >
          <button type="button" class="toggle-password" (click)="togglePasswordVisibility()">
            <i class="icon" [class.icon-show]="!showPassword" [class.icon-hide]="showPassword"></i>
          </button>
        </div>
        <div class="error-message" *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
          <span *ngIf="loginForm.get('password')?.errors?.['required']">Şifrə daxil edilməlidir.</span>
          <span *ngIf="loginForm.get('password')?.errors?.['minlength']">Şifrə ən azı 8 simvol olmalıdır.</span>
        </div>
      </div>

      <div class="form-footer">
        <a [routerLink]="['/forgot-password']" class="forgot-link">Şifrəmi unutdum</a>
      </div>

      <button type="submit" class="btn-submit" [disabled]="loginForm.invalid">Daxil ol</button>

      <div class="auth-links">
        <span>Hesabın yoxdur? <a [routerLink]="['/register']">Qeydiyyat</a></span>
      </div>

      <div class="legal-notice">
        Giriş etməklə, siz <a href="#">İstifadəçi razılaşmasını</a> və <a href="#">Qaydaları</a> ilə razı olduğunuzu təsdiq edirsiniz.
      </div>
    </form>
  </div>
</div>
